import Repository from '../Repository';

const resource = '/product';

export default {
	index(params) {
		return Repository.get(`${resource}`, { params: params });
	}
}